import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getArtworks = async (series) => {
  const params = series && series !== "All" ? { series } : {};
  const { data } = await axios.get(`${API}/artworks`, { params });
  return data;
};

export const getArtwork = async (slug) => {
  const { data } = await axios.get(`${API}/artworks/${slug}`);
  return data;
};

export const getExhibitions = async () => {
  const { data } = await axios.get(`${API}/exhibitions`);
  return data;
};

export const getSeries = async () => {
  const { data } = await axios.get(`${API}/series`);
  return data;
};

export const submitInquiry = async (payload) => {
  const { data } = await axios.post(`${API}/inquiries`, payload);
  return data;
};

export const submitContact = async (payload) => {
  const { data } = await axios.post(`${API}/contact`, payload);
  return data;
};

export const submitRsvp = async (payload) => {
  const { data } = await axios.post(`${API}/rsvp`, payload);
  return data;
};

export const releaseNote = async (note) => {
  const { data } = await axios.post(`${API}/notes/release`, { note });
  return data;
};

export const sendNoteToSelf = async (note, email, context = "becoming") => {
  const { data } = await axios.post(`${API}/notes/to-self`, { note, email, context });
  return data;
};

export const getNoteCount = async () => {
  const { data } = await axios.get(`${API}/notes/count`);
  return data;
};
